<template>
  <div class="min-h-screen flex items-center justify-center">
    <BaseCard class="max-w-lg w-full">
      <BaseCardBody v-if="unsubscribed" class="flex flex-col justify-center items-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="mb-4 text-green-600 w-12 h-12 stroke-1"
          viewBox="0 0 24 24"
          stroke="currentColor"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
          <circle cx="12" cy="12" r="9"></circle>
          <path d="M9 12l2 2l4 -4"></path>
        </svg>
        <h3 class="text-base font-semibold tracking-wide text-gray-900 mb-4">
          Unsubscribe Successful!
        </h3>
        <p class="text-sm">You have been succesfully unsubscribed from email communications.</p>
      </BaseCardBody>
      <BaseCardBody v-else-if="cancelled">
        <h3 class="text-base font-semibold tracking-wide text-gray-900 mb-4">
          Thank you for staying with us.
        </h3>
        <p class="text-sm">You will continue receiving our news and offers.</p>
      </BaseCardBody>
      <BaseCardBody v-else>
        <h3 class="text-base font-semibold tracking-wide text-gray-900 mb-4">Unsubscribe</h3>
        <p class="mb-8 text-sm">Are you sure you want to unsubscribe from these emails?</p>
        <form @submit.prevent="submitForm">
          <BaseFormInput :value="unsubscribeId" type="hidden" />
          <div class="flex justify-between">
            <BaseButton primary outline type="button" @click="cancelled = true">Cancel</BaseButton>
            <BaseButton primary>Unsubscribe from all</BaseButton>
          </div>
        </form>
      </BaseCardBody>
    </BaseCard>
  </div>
</template>

<script>
import { ApiClient } from '@/api/client';

const client = new ApiClient('/api/v1');

export default {
  props: {
    unsubscribeId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      pending: false,
      unsubscribed: false,
      cancelled: false,
    };
  },
  methods: {
    async submitForm() {
      const url = ['email/unsubscribe', this.unsubscribeId].filter(Boolean).join('/');

      try {
        this.pending = true;
        await client.post(url);
        this.unsubscribed = true;
      } catch (error) {
        //
      }
    },
  },
};
</script>
